const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CutOffCommand: any = {
    GetCutOffList: Backofficebff + '/v1/cut-off/get-cut-off-list',
    UpsertBulkShippingCompanyCutOff: Backofficebff + '/v1/cargocutoff/upsert-bulk-shipping-company-cutOff',
};
